import { render, staticRenderFns } from "./OfficialQrcode.vue?vue&type=template&id=f08e4fb6&scoped=true"
import script from "./OfficialQrcode.vue?vue&type=script&lang=js"
export * from "./OfficialQrcode.vue?vue&type=script&lang=js"
import style0 from "./OfficialQrcode.vue?vue&type=style&index=0&id=f08e4fb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08e4fb6",
  null
  
)

export default component.exports